import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"voice-wave"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.5 3.5293C17.6629 5.69969 19 8.69362 19 11.9998C19 15.306 17.6629 18.3 15.5 20.4704M11 7.52759C12.2275 8.62623 13 10.2228 13 11.9998C13 13.7768 12.2275 15.3734 11 16.472M5.9996 10.9998C6.55206 10.9998 6.99985 11.4476 7 11.9994C7 12.5516 6.55183 12.9998 5.9996 12.9998C5.44786 12.9997 5 12.552 5 11.9994C5.00015 11.4472 5.44763 10.9998 5.9996 10.9998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const VoiceWave = Vue.extend<IconProps>({
  name: 'VoiceWaveIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'voice-wave',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default VoiceWave;
